var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "change-priority-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.newPriority")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { placeholder: _vm.$t("taskModuleRules.selectPriority") },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.priority,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "priority", $$v)
              },
              expression: "localConfig.priority",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "lowest" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.lowest"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "low" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.low"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "medium" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.medium"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "high" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.high"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "highest" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.highest"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }